__turbopack_context__.v({
  "desktop-gallery": "ammMtW_desktop-gallery",
  "mobile-gallery": "ammMtW_mobile-gallery",
  "pdp-gallery": "ammMtW_pdp-gallery",
  "slider-container": "ammMtW_slider-container",
});
